import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customer = async (id?: number) => axios.get(Routes.CUSTOMER + "/" + id);

export const useCustomer = (id?: number) =>
  useQuery({
    queryKey: [Keys.REMINDER_QRY, id],
    queryFn: () => customer(id),
    cacheTime: 0,
    enabled: id ? true : false,
  });
